import { render } from "./Oncology.vue?vue&type=template&id=bb3f34fe&scoped=true"
import script from "./Oncology.vue?vue&type=script&lang=ts"
export * from "./Oncology.vue?vue&type=script&lang=ts"

import "./Oncology.vue?vue&type=style&index=0&id=bb3f34fe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bb3f34fe"

export default script